import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import { inAppBrowser } from "../../JS/inAppBrowser";
 

const ProgressBars = (props) => {
    let filled=props.filled;
    let empty= props.empty;
 console.log("from progress bars", filled, empty)
 if(filled <0 || empty <0)return(<></>);

 if(filled + empty >10){
    const filledP= Math.floor(((filled)/(filled + empty))*10);
    const emptyP = 10- filledP;
    filled=filledP;
    empty=emptyP;
 }

    return <ul class="bar-levels">
        {

            Array.from(Array(filled).keys()).map(() => {
                return <li class="complete"></li>
            })
        }
        {
            Array.from(Array(empty).keys()).map(() => {
                return <li ></li>
            })
        }

    </ul>

}

export const capitalize = (data) => {
    const s = data.toLowerCase();
    let c = s.split('')
    c[0] = c[0].toUpperCase();
    c = c.join(''); return c;
}



const Gha_ProfileInfo = (props) => {
    const [data, setData] = useState(null);
    const [retainCurrentLevel, setRetainCurrentLevel]=useState(null)

    

    const { t } = props;

    const getCardPath = (color) => {
        let path;
        console.log("colr", color)
        switch (color) {
            case 'SILVER':
                path=  require("./assests/gha_silver_blank.png");
                break;
            case 'GOLD':
                path = require("./assests/gha_gold_blank.png");
                break;
            case 'PLATINUM':
                path = require("./assests/gha_platinum_blank.png");
                break;
            case 'TITANIUM':
                path = require("./assests/gha_titanium_blank.png");
                break;
        }
        console.log("unexpected color:", color)
        return path;
    }

    const getColorCirclePath = () => {
        return "";
    }

    const handleBack=()=>{
        props.handleBack();
    }

    const openLinkHandler = (link, displayName) => {

        if (link) {
            inAppBrowser(link, {...props,menuColor:{assetFontColor:"#000000",backgroundColor:"#D0D2D7"}}, false, {displayName: displayName, dontSetCurrentWidget: true, targetUrl:link})
        }

    }


    const checkRetainingLevelGoals=(data)=>{

        const all = (data.currentMembershipNeededNights > data.currentStatsNights) ||
            (data.currentMembershipNeededStays > data.currentStatsStays) ||
            (data.currentMembershipNeededBrands > data.currentStatsBrands) ||
            (data.currentMembershipNeededEligibleRevenue > data.currentStatsEligibleRevenue);


        let retainCurrentLevel_ = {
            nights: (data.currentMembershipNeededNights > data.currentStatsNights) ? "remaining" : "completed",
            stays: (data.currentMembershipNeededStays > data.currentStatsStays) ? "remaining" : "completed",
            brands: (data.currentMembershipNeededBrands > data.currentStatsBrands) ? "remaining" : "completed",
            revenue: (data.currentMembershipNeededEligibleRevenue > data.currentStatsEligibleRevenue) ? "remaining" : "completed",
            all: all ? "remaining" : "completed"
        }

        setRetainCurrentLevel(retainCurrentLevel_ )
         
    }


    useEffect(() => {

        scrollToTop();
        console.log(props.selectedProfileDetails, "selectedProfileDetails")
        const data_ = {
            name: props.selectedProfileDetails.name,
            email: props.selectedProfileDetails.email,
            profileId: props.selectedProfileDetails.profileId,
            cardPath: getCardPath(props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "membershipInfo").data.membershipLevel),
            membershipNumber: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "membershipInfo").data.membershipNumber,
            expirationDate: moment(new Date((props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentMembershipLevel").data.expirationDate)*1000)).format(props.dateFormat.toUpperCase()),
            discoveryBalance: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "gravtyProfile").data.discoveryBalance,
            pointsRedeemed: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "gravtyProfile").data.pointsRedeemed,
            pointsAccrued: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "gravtyProfile").data.pointsAccrued,
            pointsExpired: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "gravtyProfile").data.pointsExpired,
            colorCirclePath: getColorCirclePath(props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "membershipInfo").data.membershipLevel),
            color: (props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "membershipInfo").data.membershipLevel),
            nextColor: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "nextMembershipLevel").data.level,
            currentStatsNights: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentYearStats").data.totalNightsYear,
            currentStatsBrands: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentYearStats").data.brandsYear,
            currentStatsStays: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentYearStats").data.totalStaysYear,
            currentStatsEligibleRevenue: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentYearStats").data.eligibleRevenue,

            nextMembershipNeededNights: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "nextMembershipLevel").data.nightsNeeded,
            nextMembershipNeededBrands: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "nextMembershipLevel").data.brandsNeeded,
            nextMembershipNeededStays: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "nextMembershipLevel").data.staysNeeded,
            nextMembershipNeededEligibleRevenue: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "nextMembershipLevel").data.revenueNeeded,

            currentMembershipNeededNights: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentMembershipLevel").data.nightsNeeded,
            currentMembershipNeededBrands: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentMembershipLevel").data.brandsNeeded,
            currentMembershipNeededStays: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentMembershipLevel").data.staysNeeded,
            currentMembershipNeededEligibleRevenue: props.selectedProfileDetails.membershipDetails.find((mem) => mem.type == "currentMembershipLevel").data.revenueNeeded,


        }
        console.log("from profileINfo , data_ is",data_)

        checkRetainingLevelGoals(data_);
        setData(data_);

    }, []);




    return (
        <>
            {
                data &&

                <>

                    <header class="inner-pages w-footer subpages">
                        <a class="button-back" onClick={handleBack}></a>
                        <div class="heading align-center">
                            <div class="splash-brand"><img 
                            src={`${CMSPath}${props.logo}`}                             /></div>
                        </div>
                        <div class="logout" onClick={props.handleLogoutUser}>
                            {t("gha.logout")}
                        </div>
                    </header>
                    <section class="widgets">
                        <div class="widget-header account-details">
                            <div class="widget-header-img">
                                <div class="widget-header-sub-img">
                                    <div class="account-info-details">
                                        <div class="account-user">
                                            <span class="account-name">{data.name}</span>
                                            <span class="account-number">{data.membershipNumber}</span>
                                        </div>
                                        <div class="accont-exp">{`Exp. ${data.expirationDate}`}</div>
                                    </div>
                                    <img src={data.cardPath} />
                                </div>
                                {/* <img src="http://64.176.193.36:8080/../cmsData/hoteligenceClient/widgets/USNYCPL_392_9865_widgets002_housekeeping.png" alt="Housekeeping"> */}
                            </div>
                            <div class="widget-header-title"> {t("gha.my_account")}</div>
                        </div>
                        <div id="GHAAccount" class="widgets sign-up spa-listing">
                            <div class="row account-info stay-body">
                                <div class="stay-info">
                                    <div class="stay-arrival">
                                        <div class="heading"> {t("gha.member_nr")}</div>
                                        <div class="body">
                                            <p>{data.membershipNumber}</p>
                                        </div>
                                    </div>
                                    <div class="stay-departure">
                                        <div class="heading">{t("gha.balance")} </div>
                                        <div class="body">
                                            <p>{data.discoveryBalance}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="stay-info">
                                    <div class="stay-arrival">
                                        <div class="heading">{t("gha.expiration_date")}</div>
                                        <div class="body">
                                            <p>{data.expirationDate}</p>
                                        </div>
                                    </div>
                                    <div class="stay-departure">
                                        <div class="heading"> {t("gha.membership_level")}</div>
                                        <div class="body">
                                            <p class="level-status"><span class={`level-status ${data.color.toLowerCase()}`}></span> {data.color}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="stay-info">
                                    <div class="stay-arrival">
                                        <div class="heading"> {t("gha.points_redeemed")}</div>
                                        <div class="body">
                                            <p>{data.pointsRedeemed}</p>
                                        </div>
                                    </div>
                                    <div class="stay-departure">
                                        <div class="heading"> {t("gha.points_accrued")}</div>
                                        <div class="body">
                                            <p>{data.pointsAccrued}</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="stay-info">
                                    <div class="stay-arrival">
                                        <div class="heading"> {t("gha.points_expired")}</div>
                                        <div class="body">
                                            <p>{data.pointsExpired}</p>
                                        </div>
                                    </div>

                                </div>


                            </div>

                            {data.color != "TITANIUM" &&
                                <div class="row account-progress">
                                    <h3>{`Progress to ${data.nextColor}`}</h3>
                                    <p>{t("gha.level_next_progess_heading")} </p>
                                    <div class="progress-bar">
                                        {
                                            ["nights", "stays", "brands", "revenue"].map(field => {
                                                let current=-1;
                                                let neededMore=-1;
                                                switch (field) {
                                                    case "nights":
                                                        current = data.currentStatsNights;
                                                        neededMore = data.nextMembershipNeededNights - data.currentStatsNights;
                                                        break;
                                                    case "stays":
                                                        current = data.currentStatsStays;
                                                        neededMore = data.nextMembershipNeededStays - data.currentStatsStays;
                                                        break;
                                                    // TODO:
                                                    case "brands":
                                                        current = data.currentStatsBrands;
                                                        neededMore = data.nextMembershipNeededBrands - data.currentStatsBrands;
                                                        break;
                                                    case "revenue":
                                                        current = data.currentStatsEligibleRevenue;
                                                        neededMore = data.nextMembershipNeededEligibleRevenue - data.currentStatsEligibleRevenue;
                                                        break;

                                                }
                                                console.log("current/filled", current)
                                                console.log("empty/needed more",neededMore)
                                                { return (isNaN(current) || isNaN(neededMore) || current<0 || neededMore<0 )
                                                    ?  ( <></>)
                                                    : ( 
                                                      <>
                                                      <div class={`next-level ${data.nextColor} ${field}`}>
                                                    
                                                        { 
                                                            <ProgressBars filled={current} empty={neededMore} />
                                                        }


                                                        <div class="progress-bar-details">
                                                            {
                                                                (neededMore ==0 )
                                                                ? `${capitalize(field)} goal completed.`
                                                                :field == "revenue"
                                                                    ? `${props.currencyCode} ${neededMore} more to spend`
                                                                    : `${neededMore} more ${field} to ${capitalize(data.nextColor)}`

                                                            }

                                                        </div>
                                                        </div>
                                                    </>)
                                                 }
                                             
                                            })
                                        }

                                        
                                    </div>






                                    

                                </div>

                            }





                            <div class="row">
                                <h3>{t("gha.level_current_progess_heading")}</h3>
                                
                                    {
                                        retainCurrentLevel.all=="remaining"
                                        ?
                                         
                                         <ul>
                                                {

                                                (retainCurrentLevel.nights == "remaining") ?
                                            <li><div class={`retain-level ${data.color} nights`}>{`Book ${(data.currentMembershipNeededNights - data.currentStatsNights)} more night${(data.currentMembershipNeededNights - data.currentStatsNights) == 1 ? "" : 's'} to retain your current level`}</div></li>:null
                                                }
                                                                        
                                                {
                                                        (retainCurrentLevel.stays == "remaining") ?
                                        <li><div class={`retain-level ${data.color} stays`}>{`Book ${(data.currentMembershipNeededStays - data.currentStatsStays)} more stay${(data.currentMembershipNeededStays - data.currentStatsStays) == 1 ? "" : 's'} to retain your current level`}</div></li>:null

                                                }
                                                {

                                                            (retainCurrentLevel.brands == "remaining") ?
                                        <li><div class={`retain-level ${data.color} brands`}>{`Book ${(data.currentMembershipNeededBrands - data.currentStatsBrands)} more brand${(data.currentMembershipNeededBrands - data.currentStatsBrands) == 1 ? "" : 's'} to retain your current level`}</div></li>:null

                                                    }
                                                    {       
                                                                (retainCurrentLevel.revenue == "remaining") ?
                                        <li> <div class={`retain-level ${data.color} revenue`}>{`Spend ${props.currencyCode} ${(data.currentMembershipNeededEligibleRevenue - data.currentStatsEligibleRevenue)} more to retain your current level`}
                                        </div></li>:null
                                    }
                                        </ul>
                                     
                                        : <p>{t("gha.all_milestones_covered_msg")}</p>
                                    }
            
                              
                            </div>


                            {/* 
                    <div class="row rewards">
                        <div class="info-list">
                            <div class="info-list-body">
                                <h5>Titanium</h5>
                                <p>Stay 30 nights or Spend USD 15,000 or Stay with 3 brands</p>
                                <ul class="icon-list">
                                    <li><span class="icon"><img src="ico_spend.svg" /></span> Spend D$</li>
                                    <li><span class="icon"><img src="ico_rates.svg" /></span> Member Rates</li>
                                    <li><span class="icon"><img src="ico_status_share.svg" /></span> Status Sharing</li>
                                    <li><span class="icon"><img src="ico_early_checkin.svg" /></span> Early Check-in</li>
                                    <li><span class="icon"><img src="ico_brand.svg" /></span> Brand Benefits</li>
                                    <li><span class="icon"><img src="ico_exclusive.svg" /></span> Exclusive Offers</li>
                                    <li><span class="icon"><img src="ico_late_checkout.svg" /></span> Late Check-out</li>
                                    <li><span class="icon"><img src="ico_48.svg" /></span> 48hrs Availability</li>
                                    <li><span class="icon"><img src="ico_double.svg" /></span> Double Room Upgrade</li>
                                    <li><span class="icon"><img src="ico_exp.svg" /></span> Experiences</li>
                                    <li><span class="icon"><img src="ico_earn.svg" /></span> Earn D$ (7%)</li>
                                    <li><span class="icon"><img src="ico_wifi.svg" /></span> Complimentary Wi-Fi</li>
                                    <li><span class="icon"><img src="ico_welcome2.svg" /></span> Welcome Amenity</li>
                                </ul>
                            </div>
                        </div>
                    </div> */}
                            <div class="row access-details">
                                <div class="form-controls">
                                    {/* <button class="primary w-100 margin-bottom-1">Book now and level up</button> */}
                                    {props.allProfilesData.length > 1 && <button class="primary w-100 margin-bottom-1" onClick={props.handleSwitchClick}>{t("gha.switch_profile")}</button>}
                                   </div>
                                   
                                   {props.allProfilesData.length == 1 && <div class="form-controls gha-delete-account">
                                     <button class="primary w-100 margin-bottom-1" onClick={()=>{openLinkHandler(props.requiredLinks.deleteAccountLink,"Delete Gha Account")}}>
                                        
                                          
                                            <span style={{color:"white"}}>{t("gha.delete_account")} </span></button>

                                    {/* <button onClick={props.handleLogoutUser}> LOGOUT</button> */}
                                </div>}
                            </div>
                        </div>
                    </section>
                </>

            }


        </>

    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : ""
    };
};

export default connect(mapStateToProps, { setGoHome,  closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_ProfileInfo)
);